const ZCTA_NO_DATA_COLOR = '#b8b8b8';

/** risk_score 0-1 → CSS color string (green → yellow → red). */
export function riskScoreToColor(score) {
  if (score == null || Number.isNaN(score)) return ZCTA_NO_DATA_COLOR;
  const t = Math.max(0, Math.min(1, Number(score)));
  const h = Math.round((1 - t) * 120); // 120=green, 0=red
  return `hsl(${h}, 70%, 42%)`;
}

/** Strip /month, /mo suffix so price badge shows only the dollar amount (e.g. "$3,800"). */
export function priceOnly(amount) {
  if (!amount) return '';
  return String(amount).trim()
    .replace(/\s*\/\s*month.*$/i, '')
    .replace(/\s*\/\s*mo\.?\s*$/i, '')
    .trim() || String(amount).trim();
}

/**
 * Build Google Maps and Apple Maps URLs.
 * Prefer place listing: use placeId when available; otherwise use placeName so search opens the actual place.
 * Google Maps search requires a `query` param; use `query_place_id` as a separate param for the place ID
 * (see https://developers.google.com/maps/documentation/urls/get-started#search).
 *
 * @param {number} lat
 * @param {number} lng
 * @param {string|null} placeId - Google Place ID; when set, link uses query_place_id so Maps opens the place listing.
 * @param {string} [placeName] - Fallback search query (required by Google when using query_place_id); also used when no placeId.
 */
export function mapsUrls(lat, lng, placeId, placeName) {
  const fallbackQuery = placeName && placeName.trim() ? placeName.trim() : `${lat},${lng}`;
  const encodedQuery = encodeURIComponent(fallbackQuery);
  const appleQ = encodeURIComponent(placeName || `${lat},${lng}`);

  if (placeId) {
    return {
      google: `https://www.google.com/maps/search/?api=1&query=${encodedQuery}&query_place_id=${encodeURIComponent(placeId)}`,
      apple: `https://maps.apple.com/?ll=${lat},${lng}&q=${appleQ}`,
    };
  }
  return {
    google: `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`,
    apple: `https://maps.apple.com/?ll=${lat},${lng}&q=${encodedQuery}`,
  };
}
